/* eslint-disable no-nested-ternary */
/* eslint-disable arrow-parens */
/* eslint-disable func-style */
import React from 'react'
import {formatCurrencyByLocale} from '../../util/formatCurrencyByLocale'

/**
 * Logic for the Product Pricing Component
 * First check if the price is for Rental Product
 * Else, check if price is on sale
 * Else, output the normal outright price
 */
const ProductPrice = props => {
  const {
    compareAtPrice,
    outrightPrice,
    dailyRentalPrice,
    isRentalOnly
  } = props

  const isOnSale = () => compareAtPrice > 0 && compareAtPrice > outrightPrice
  const originalRentalPrice = isOnSale ? (compareAtPrice * 0.055 * 12 / 52 / 7) : dailyRentalPrice

  return (
      <React.Fragment>
        {isRentalOnly ? (
            <React.Fragment>
              <div className="text-center">
                <p className="rent-section smaller-money foreground-darkest-green">
                  <span
                      className="dollar-value weight-bold price"
                      dangerouslySetInnerHTML={{ __html: formatCurrencyByLocale({
                          amount: dailyRentalPrice,
                          format: `{{ amount }}`
                        })}
                      }>
                  </span>
                  <span className="per-day">/day</span>
                </p>
                {isOnSale() ? (
                    <React.Fragment>
                      <small className={`light foreground-strikeout`}>
                        Was <span
                          className="dollar-value weight-bold price"
                          dangerouslySetInnerHTML={{ __html: formatCurrencyByLocale({
                              amount: originalRentalPrice / 7,
                              format: `{{ amount }}`
                            })}} />
                        <span className="per-day">/day</span>
                      </small>
                    </React.Fragment>
                ): ``}
                <p className="rental-message">
                  Rent—Try—Buy
                </p>
              </div>
            </React.Fragment>
        ) : (
          <React.Fragment>
            <div className={`price-row`}>
              <div className={`rental-price`}>
                <React.Fragment>
                  <p className="rent-section smaller-money foreground-darkest-green">
                    <span
                        className="dollar-value weight-bold price"
                        dangerouslySetInnerHTML={{ __html: formatCurrencyByLocale({
                            amount: dailyRentalPrice,
                            format: `{{ amount }}`
                          })}
                        }>
                    </span>
                    <span className="per-day">/day</span>
                  </p>
                  {isOnSale() ? (
                      <React.Fragment>
                        <small className={`foreground-strikeout`}>
                          Was <span
                            className="dollar-value weight-bold price"
                            dangerouslySetInnerHTML={{ __html: formatCurrencyByLocale({
                                amount: originalRentalPrice,
                                format: `{{ amount }}`
                              })}} />
                          <span className="per-day">/day</span>
                        </small>
                      </React.Fragment>
                  ): ``}
                  <p className="rental-message">
                    Rent—Try—Buy
                  </p>

                </React.Fragment>
              </div>
              <div className={`purchase-price`}>
                <small className={`outright-label`}>Purchase outright</small>
                  <p
                      className="smaller-money"
                      dangerouslySetInnerHTML={{ __html: formatCurrencyByLocale({
                          amount: `${Math.round(outrightPrice)}`,
                          funding: `{{ amount_no_decimals }}`
                        })}
                      }></p>
                  {isOnSale() ? (
                  <small className="light foreground-strikeout">
                    Was <span
                      dangerouslySetInnerHTML={{ __html: formatCurrencyByLocale({
                          amount: `${Math.round(compareAtPrice)}`,
                          format: `{{ amount_no_decimals }}`
                        })}
                      }></span>
                  </small>) : `` }
              </div>
            </div>

          </React.Fragment>
        )}
      </React.Fragment>
  )
}

export default ProductPrice
